import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";
import { SendNotification } from "components/SendNotification";
import { toast } from 'react-toastify';

export const saveWorkRequirementSchedule = async (payload) => {
  
  const accesstoken = getToken();
  if (!accesstoken) {
    throw new Error("No access token");
  }

  const response = await fetch(`${dev_baseUrl}/WorkRequirement/save`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accesstoken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  console.log(data)

  if (!response.ok || data.isError || !data.result) {
    // bubble up the API error
    throw new Error(data?.message || "Unknown error saving schedule");
  }

  // success: return whatever you need
  return data;
};


export const getWorkRequirement = async ({ workReqID, entityID }) => {
  const accesstoken = getToken();
  if (!accesstoken) {
    console.warn("Access token is not available.");
    return null;
  }
  try {
    const url = `${dev_baseUrl}/WorkRequirement/get?workReqID=${workReqID}&entityID=${entityID}`;
    const resp = await fetch(url, {
      method: "GET",
      headers: { Authorization: `Bearer ${accesstoken}` },
    });
    const data = await resp.json();
    if (resp.ok && !data.isError && data.result?.length) {
      return data.result[0];
    } else {
      // toast.error(data?.message || "Error fetching ser", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: true,
      // });
      console.log(data)
      return null;
    }
  } catch (err) {
    console.error("Error fetching work requirement:", err);
    toast.error("API Error", { position: "top-right", autoClose: 5000 });
    return null;
  }
};

export const saveJob = async (payload, navigate) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {

        const response = await fetch(`${dev_baseUrl}/Job/save`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        // console.log(payload)

        const data = await response.json();
        console.log("data")
        console.log(data)
        // Handle the response format
        if (response.ok && !data.isError) {
            SendNotification(navigate);
            return data;
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unable to Update Job. Please try again later!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('Unable to Update Job. Please try again later!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return ;
    }
  } else {

    console.warn("Access token is not available.");
  }

};

export const getJobLabors = async ({ workReqID, jobID, jobLaborID = 0 }) => {
  const accesstoken = getToken();
  if (!accesstoken) throw new Error("No access token");
  const url = `${dev_baseUrl}/JobLabor/get?workReqID=${workReqID}&jobID=${jobID}&jobLaborID=${jobLaborID}`;
  const resp = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${accesstoken}` },
  });
  const data = await resp.json();
  // console.log(data)
  if (resp.ok && !data.isError) return data.result;
  // toast.error(data?.message || "Error fetching job labor");
  return [];
};

/**
 * Fetch all employees.
 */
export const getEmployees = async () => {
  const accesstoken = getToken();
  if (!accesstoken) throw new Error("No access token");
  const url = `${dev_baseUrl}/Employee/get/0`;
  const resp = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${accesstoken}` },
  });
  const data = await resp.json();
  if (resp.ok && !data.isError) return data.result;
  toast.error(data?.message || "Error fetching employees");
  return [];
};


export const getAllServiceWorkRequirement = async (entityID) => {
  const accesstoken = getToken();
  if (!accesstoken) {
    console.warn("Access token is not available.");
    return null;
  }
  try {
    const url = `${dev_baseUrl}/WorkRequirement/get?workReqID=0&entityID=${entityID}`;
    const resp = await fetch(url, {
      method: "GET",
      headers: { Authorization: `Bearer ${accesstoken}` },
    });
    const data = await resp.json();
    if (resp.ok && !data.isError && data.result?.length) {
      return data.result;
    } else {
      // toast.error(data?.message || "Error fetching ser", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: true,
      // });
      console.log(data)
      return null;
    }
  } catch (err) {
    console.error("Error fetching work requirement:", err);
    toast.error("API Error", { position: "top-right", autoClose: 5000,  theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              }, });
    return null;
  }
};